import React from 'react'

const Attention = (props) => (
    <svg width={props.width ? props.width : 14} height={props.height ? props.height : 14} viewBox="0 0 14 14" fill={props.color ? props.color : '#EB5757'}
         xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M7.00016 0.333252C10.6821 0.333252 13.6668 3.31802 13.6668 6.99992C13.6668 10.6818 10.6821 13.6666 7.00016 13.6666C3.31826 13.6666 0.333496 10.6818 0.333496 6.99992C0.333496 3.31802 3.31826 0.333252 7.00016 0.333252ZM6.3335 9.66659H7.66683V10.9999H6.3335V9.66659ZM7.00016 2.99992C7.36835 2.99992 7.66683 3.2984 7.66683 3.66658V7.66658C7.66683 8.03477 7.36835 8.33325 7.00016 8.33325C6.63197 8.33325 6.3335 8.03477 6.3335 7.66658V3.66658C6.3335 3.2984 6.63197 2.99992 7.00016 2.99992Z"
              />
    </svg>
)

export default Attention
